import { Heading } from '../../../../Typography/Heading';
import { Paragraph } from '../../../../Typography/Paragraph';
import { type WizardStepType } from '../../index';
import { WizardStepTitle, WizardStepWrapper } from './styles';

export const WizardStep = ({
  step: { component, title, description },
}: {
  step: WizardStepType;
}) => {
  return (
    <WizardStepWrapper>
      {title && (
        <WizardStepTitle>
          <Heading as="h2" variant="small" id="wizard-title">
            {title}
          </Heading>
          {description && <Paragraph variant="large">{description}</Paragraph>}
        </WizardStepTitle>
      )}
      {component}
    </WizardStepWrapper>
  );
};
